<template>
    <div class="footer">
      &copy; {{ new Date().getFullYear() }} My Application. All rights reserved.
    </div>
  </template>
  
  <style scoped>
  .footer {
    background-color: blue;
    color: white;
    text-align: center;
    padding: 5px 0;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1000;
  }
  </style>
  